// @ts-nocheck
import React, { ReactNode } from "react";
import MediaQuery, { useMediaQuery } from "react-responsive";

const MOBILE_BREAKPOINT = 767;

/**
 *  Orient on tailwindcss breakpoints
 *
 *  https://tailwindcss.com/docs/responsive-design
 */

export function useMobileResolution() {
  return useMediaQuery({
    maxWidth: MOBILE_BREAKPOINT,
  });
}

export function IsMobile({
  children,
}: {
  children: (isMobile: boolean) => ReactNode;
}) {
  return (
    <MediaQuery maxWidth={MOBILE_BREAKPOINT}>
      {(isMobile) => {
        return children(isMobile);
      }}
    </MediaQuery>
  );
}
